import React from 'react';
import '../../styles/LevelsInfoScreen.css';

export default function LevelsInfoScreen({
  text,
  levels
}) {
  return (
    <div className="levels-info-screen quiz-screen">
      <div className="quiz-card">

        {text && (
          <div
            className={`
            hero-content
              font-${text?.fontSize ?? 'md'}
            `}
            dangerouslySetInnerHTML={{ __html: text.value }}
          />
        )}


        <div className="levels-grid">
          {levels.map((level, index) => {
            const isLast = index === levels.length - 1;

            return (
              <div
                key={index}
                className={`
                  level-card
                  ${level?.isExtraLevel ? 'extra-level' : ''}
                  ${isLast ? 'level-card--full' : ''}
                `}
              >

                <div className="level-card-header">
                    <span className="level-badge">
                        Рівень {level.level} 
                    </span>

                    {!level.isExtraLevel && (
                        <span
                        className={`level-status ${
                            level.isFinished ? 'status-finished' : 'status-in-progress'
                        }`}
                        >
                        <span className="level-status-text">
                            {level.isFinished ? 'Завершено' : 'У процесі'}
                        </span>
                        </span>
                    )}

                    {level.isExtraLevel && !level.isFinished && (
                        <span className="level-status status-extra">
                            <span className="level-status-text">
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.5983 1.05334C7.2914 -0.351032 9.29399 -0.351033 9.98709 1.05334L11.0859 3.27973C11.3611 3.8374 11.8931 4.22394 12.5086 4.31337L14.9655 4.67039C16.5153 4.89559 17.1342 6.80017 16.0127 7.89332L14.2348 9.62632C13.7895 10.0604 13.5863 10.6858 13.6914 11.2988L14.1111 13.7458C14.3759 15.2894 12.7557 16.4665 11.3695 15.7377L9.17196 14.5824C8.6215 14.293 7.96389 14.293 7.41342 14.5824L5.21585 15.7377C3.82965 16.4665 2.20952 15.2894 2.47426 13.7458L2.89396 11.2988C2.99909 10.6858 2.79587 10.0604 2.35054 9.62632L0.572666 7.89332C-0.548794 6.80017 0.0700414 4.89559 1.61986 4.67039L4.07682 4.31337C4.69226 4.22394 5.22428 3.8374 5.49951 3.27973L6.5983 1.05334Z" fill="#F4B7EA"/>
                                </svg>
                            </span>
                        </span>
                    )}
                    </div>


                <div className="level-card-body">
                  {level.image && (
                    <img
                      src={level.image}
                      alt=""
                      className="level-image"
                    />
                  )}

                  <div className="level-progress" dangerouslySetInnerHTML={{__html: level.progress}}>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
}

